import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import CustomerDelivery from "./pages/CustomerDelivery";

function App() {
  return (
    <Routes>
      <Route path="/customer/:qrCode" element={<CustomerDelivery />} />
      <Route path="/:qrCode" element={<CustomerDelivery />} />
      <Route path="*" element={<Navigate to="/customer/gecersiz-qr" replace />} />
    </Routes>
  );
}

export default App;
